import { apiRequest, ApiError } from './client'
import type { CreateShareRequest, CreateShareResponse, ShareDetails, UpdateShareRequest } from '@/types/share'

export { ApiError }

export async function createShare(
  data: CreateShareRequest,
  options?: { apiKey?: string }
): Promise<CreateShareResponse> {
  const headers: Record<string, string> = {}
  if (options?.apiKey) {
    headers['X-Myrkup-API-Key'] = options.apiKey
  }
  return apiRequest<CreateShareResponse>('/shares', {
    method: 'POST',
    body: data,
    headers,
  })
}

export async function getShareMeta(
  shareId: string,
  options?: { apiKey?: string }
): Promise<ShareDetails> {
  const headers: Record<string, string> = {}
  if (options?.apiKey) {
    headers['X-Myrkup-API-Key'] = options.apiKey
  }
  return apiRequest<ShareDetails>(`/shares/${shareId}/meta`, { headers })
}

export async function getShareBlob(shareId: string): Promise<string> {
  const response = await apiRequest<{ blob: string }>(`/shares/${shareId}/blob`)
  return response.blob
}

export async function consumeShare(shareId: string): Promise<void> {
  await apiRequest(`/shares/${shareId}/consume`, {
    method: 'POST',
  })
}

export async function revokeShare(shareId: string, managementToken: string): Promise<void> {
  await apiRequest(`/shares/${shareId}`, {
    method: 'DELETE',
    body: { managementToken },
  })
}

export async function getShareByToken(token: string): Promise<ShareDetails & { shareUrl: string }> {
  return apiRequest<ShareDetails & { shareUrl: string }>(`/manage/${token}`)
}

export async function getShareBlobByToken(token: string): Promise<string> {
  const response = await apiRequest<{ blob: string }>(`/manage/${token}/blob`)
  return response.blob
}

export async function updateShare(token: string, data: UpdateShareRequest): Promise<{ updatedAt: number }> {
  return apiRequest<{ updatedAt: number }>(`/manage/${token}`, {
    method: 'PUT',
    body: data,
  })
}

export async function updateShareMetadata(
  apiKey: string,
  shareId: string,
  metadata: { folderPath?: string; tags?: string }
): Promise<{ success: boolean }> {
  return apiRequest<{ success: boolean }>(`/shares/${shareId}/meta`, {
    method: 'PATCH',
    body: metadata,
    headers: { 'X-Myrkup-API-Key': apiKey },
  })
}

export async function fetchUrl(url: string): Promise<string> {
  const response = await apiRequest<{ content: string }>('/fetch-url', {
    method: 'POST',
    body: { url },
  })
  return response.content
}
